/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { IResourceProps, IResourceId } from 'apmui/resource/ResourceLoader';
import WebtopResourceModel from 'apmui/resource/WebtopResourceModel';
import { RESOURCE } from 'apmui/resource/ResourceType';

/** mcp: webtop_section_initial_state_t */
enum WEBTOP_SECTION_STATE {
    COLLAPSED = 0 /** mcp: WEBTOP_SECTION_COLLAPSED */,
    EXPANDED = 1 /** mcp: WEBTOP_SECTION_EXPANDED */,
}

/** mcp: webtop_section_resources_sort_t */
enum WEBTOP_SECTION_SORT {
    ALPHABETICALLY = 0 /** mcp: WEBTOP_SECTION_SORT_ALPHABETICALLY */,
    BY_PRIORITY = 1 /** mcp: WEBTOP_SECTION_SORT_BY_PRIORITY */,
    BY_CAPTION /** mcp: WEBTOP_SECTION_SORT_BY_CAPTION */,
}

class WebtopSectionModel extends WebtopResourceModel {
    static readonly propNames = ['initial_state', 'sort', 'ws_order', ...WebtopResourceModel.propNames];

    type: RESOURCE.WEBTOP_SECTION = RESOURCE.WEBTOP_SECTION;
    assignedResources: IResourceId[];

    initExpanded: WEBTOP_SECTION_STATE;
    sort: WEBTOP_SECTION_SORT;
    order: number;

    constructor(id: string, resource: IResourceProps) {
        super(id, resource);

        this.initExpanded =
            resource.props.initial_state === '1' ? WEBTOP_SECTION_STATE.EXPANDED : WEBTOP_SECTION_STATE.COLLAPSED;
        this.sort = parseInt(resource.props.sort, 10);
        this.assignedResources = resource.assignedResources || [];

        switch (resource.props.ws_order) {
            case Number.POSITIVE_INFINITY.toString():
                this.order = Number.POSITIVE_INFINITY;
                break;
            case Number.NEGATIVE_INFINITY.toString():
                this.order = Number.NEGATIVE_INFINITY;
                break;
            default:
                this.order = parseInt(resource.props.ws_order, 10);
                break;
        }

        this.undefinedIconToDefault();
    }

    getPropNames(): string[] {
        return WebtopSectionModel.propNames;
    }
}

export { WebtopSectionModel as default, WEBTOP_SECTION_STATE, WEBTOP_SECTION_SORT };
